import copy from "../../../copy/en/sales-org.json" with { type: "json" };
import { Outlet, useLocation } from "react-router";
import { useMe } from "../../auth/MeProvider.js";
import { SubNav } from "../../components/ui/Tabs.js";

export const SALES_ORG_PATH = "/sales-organization";
export const LINKS_PATH = `${SALES_ORG_PATH}/links`;
export const DISPUTES_PATH = `${SALES_ORG_PATH}/disputes`;

export function linkPath(id: string, search = "", returnTo?: string): string {
  const params = new URLSearchParams(search);
  if (returnTo) params.set("returnTo", returnTo);
  return `${LINKS_PATH}/${encodeURIComponent(id)}${params.size ? `?${params}` : ""}`;
}

/** Keep Practice drill-downs anchored without accepting arbitrary redirect URLs. */
export function linkReturnTarget(search: string): { to: string; label: string } {
  const params = new URLSearchParams(search);
  const requested = params.get("returnTo");
  if (requested && /^\/practices\/[a-zA-Z0-9_-]+(?:\?[^#\\]*)?$/.test(requested)) {
    return { to: requested, label: copy.SalesOrgLayout.practice };
  }
  const list = new URLSearchParams();
  if (params.get("q")) list.set("q", params.get("q")!);
  if (["active", "expired", "revoked"].includes(params.get("status") ?? "")) list.set("status", params.get("status")!);
  return { to: `${LINKS_PATH}${list.size ? `?${list}` : ""}`, label: copy.SalesOrgLayout.signingLinks };
}

/** People directory and the established signing-link workspace. */
export function SalesOrgLayout() {
  const { hasCap } = useMe();
  const { pathname } = useLocation();
  return (
    <>
      {pathname.replace(/\/$/, "") !== SALES_ORG_PATH ? <SubNav
        ariaLabel={copy.SalesOrgLayout.peopleAndAttribution}
        items={[
          { to: SALES_ORG_PATH, label: copy.SalesOrgLayout.organization, end: true },
          { to: LINKS_PATH, label: hasCap("view:all") ? copy.SalesOrgLayout.signingLinks : copy.SalesOrgLayout.createSigningLink },
          ...(hasCap("disputes:create") ? [{ to: DISPUTES_PATH, label: copy.SalesOrgLayout.attributionDisputes }] : []),
        ]}
      /> : null}
      <Outlet />
    </>
  );
}
